import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { isRequestActive } from "redux-request-loading";
import { Container, Loader } from "semantic-ui-react";

import { PpqManagerSection } from "@teamprevent/common/ppq/components/PpqManagerSection";
import { PpqEmployeeSection } from "@teamprevent/common/ppq/components/PpqEmployeeForm";
import {
    selectManagerSectionQuestionnaireAsQuestionnaireConfig,
    selectEmployeeSectionQuestionnaireAsQuestionnaireConfig
} from "@teamprevent/common/ppq/selector";

import { LOAD_PPQ_DETAILS } from "../actionTypes";
import { ApplicationState } from "../../applicationState";
import { evidenceApiUrl } from "../models";
import { loadWorkGroups } from "../../crud/workGroup";
import { useCustomMedicalTypes } from "../../customMedicalTypes/hooks/useCustomMedicalTypes";
import { loadPpqDetails } from "../actions";

export const ReadOnlyPpqForm: React.FunctionComponent = () => {

    const customerId = useSelector((state: ApplicationState) => state.router.params?.customerId);
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const isLoading = useSelector((state: ApplicationState) => isRequestActive(state, LOAD_PPQ_DETAILS));
    const managerSectionQuestionnaireConfig = useSelector((state: ApplicationState) => selectManagerSectionQuestionnaireAsQuestionnaireConfig(state));
    const employeeSectionQuestionnaireConfig = useSelector((state: ApplicationState) => selectEmployeeSectionQuestionnaireAsQuestionnaireConfig(state));
    const customerWorkGroups = useSelector((state: ApplicationState) => state.workGroups);
    const { customMedicalTypes, isLoaded } = useCustomMedicalTypes({ enable: true });

    const dispatch = useDispatch();

    React.useEffect(() => {
        if (customerId) {
            dispatch(loadWorkGroups({ customerId }));
        }

        if (ohCaseId)
        {
            dispatch(loadPpqDetails({ ohCaseId }));
        }
    }, [customerId, dispatch, ohCaseId]);

    if (isLoading || !isLoaded) {
        return <Loader active />;
    }

    return (
        <Container>
            <h2>Pre-placement Questionnaire</h2>
            <PpqManagerSection
                readonly
                questionnaireConfig={managerSectionQuestionnaireConfig}
                customerWorkGroups={customerWorkGroups}
                customMedicalTypes={customMedicalTypes}
            />
            <PpqEmployeeSection
                readonly
                questionnaireConfig={employeeSectionQuestionnaireConfig}
                evidenceApiUrl={evidenceApiUrl}
            />
        </Container>
    );
};
